import { clearAccessToken, getAccessToken } from "./accessToken";

const AUTH_SESSION_MARKER_KEYS = ["user_id", "nom_complet"];

export function hasKnownAuthSession(accessToken = getAccessToken()) {
    return Boolean(
        accessToken ||
        AUTH_SESSION_MARKER_KEYS.some((key) => sessionStorage.getItem(key))
    );
}

export function clearKnownAuthSession() {
    AUTH_SESSION_MARKER_KEYS.forEach((key) => sessionStorage.removeItem(key));
    sessionStorage.removeItem("verdictia_auth_fade");
    clearAccessToken();
}
